"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dayjs_1 = require("./dayjs");
var date_1 = require("./date");
var dates_1 = require("../constants/dates");
var Discount_1 = require("../models/Discount");
exports.canDiscountPassLoyaltyRestriction = function (discount, customer, externalCustomerLoyaltyTierId) {
    var discountLoyaltyTiers = discount.loyaltyTiers;
    var customerLoyaltyTierId = customer && customer.loyaltyTierId;
    if (discountLoyaltyTiers && discountLoyaltyTiers.length > 0) {
        var loyaltyIdToCheck_1 = customerLoyaltyTierId || externalCustomerLoyaltyTierId;
        if (!loyaltyIdToCheck_1) {
            return false;
        }
        return discountLoyaltyTiers.some(function (loyaltyTier) { return loyaltyTier.id === loyaltyIdToCheck_1; });
    }
    var discountLoyaltyTierId = discount.loyaltyTierId;
    if (!discountLoyaltyTierId) {
        return true;
    }
    if (customerLoyaltyTierId) {
        return discountLoyaltyTierId === customerLoyaltyTierId;
    }
    if (externalCustomerLoyaltyTierId) {
        return discountLoyaltyTierId === externalCustomerLoyaltyTierId;
    }
    return false;
};
exports.canDiscountPassLoyaltyPointsRestriction = function (_a) {
    var discount = _a.discount, remainingLoyaltyPoints = _a.remainingLoyaltyPoints, isGrowthLoyaltyActive = _a.isGrowthLoyaltyActive;
    // Growth uses a reservation system and takes that into consideration when listing rewards for a customer
    if (isGrowthLoyaltyActive) {
        return true;
    }
    var discountLoyaltyCost = discount.loyaltyCost;
    if (discountLoyaltyCost > 0 && discountLoyaltyCost > remainingLoyaltyPoints) {
        return false;
    }
    return true;
};
exports.canDiscountPassTimeRestriction = function (discount, timezone) {
    var applyDateRestriction = discount.applyDateRestriction, isRecurring = discount.isRecurring, startDate = discount.startDate, endDate = discount.endDate, startTime = discount.startTime, endTime = discount.endTime;
    if (applyDateRestriction) {
        if (isRecurring) {
            // check days of the week
            var day = dayjs_1.dayjs();
            var dayOfWeek = timezone ? day.tz(timezone).day() : day.day();
            var dayOfWeekInString = dates_1.mapDayOfWeek[dayOfWeek];
            if (!discount[dayOfWeekInString]) {
                return false;
            }
        }
        else {
            // check date range
            if (startDate && endDate && !date_1.isBetweenTwoDates(startDate, endDate, timezone)) {
                return false;
            }
        }
        // check time
        if (startTime && endTime && !date_1.isBetweenTwoTimes(startTime, endTime, timezone)) {
            return false;
        }
    }
    return true;
};
exports.calculateDiscountAmountBasedOnType = function (productPrice, discountAmount, discountType) { return (discountType === Discount_1.DiscountTypes.PERCENT
    ? Math.round(productPrice * (discountAmount / 100))
    : discountAmount); };
exports.getBestAutomaticDiscount = function (productPrice, availableDiscounts) {
    if (availableDiscounts.length === 0)
        return undefined;
    return availableDiscounts.reduce(function (bestDiscount, currentDiscount) {
        var currentAmount = exports.calculateDiscountAmountBasedOnType(productPrice, currentDiscount.amount, currentDiscount.type);
        var bestAmount = exports.calculateDiscountAmountBasedOnType(productPrice, bestDiscount.amount, bestDiscount.type);
        if (currentAmount > bestAmount) {
            return currentDiscount;
        }
        if (currentAmount === bestAmount) {
            return new Date(currentDiscount.updateDate) > new Date(bestDiscount.updateDate) ? currentDiscount : bestDiscount;
        }
        return bestDiscount;
    });
};
exports.availableProductDiscounts = function (_a) {
    var allDiscounts = _a.allDiscounts, productId = _a.productId, categoryId = _a.categoryId, automatic = _a.automatic, timezone = _a.timezone, shouldOverrideDiscountsTimeRestrictions = _a.shouldOverrideDiscountsTimeRestrictions, customer = _a.customer, externalCustomerLoyaltyTierId = _a.externalCustomerLoyaltyTierId, remainingLoyaltyPoints = _a.remainingLoyaltyPoints, isGrowthLoyaltyActive = _a.isGrowthLoyaltyActive, flattenedCategories = _a.flattenedCategories;
    return allDiscounts.filter(function (discount) {
        if (discount.applyType !== 'products') {
            return false;
        }
        // Loyalty
        if (!exports.canDiscountPassLoyaltyRestriction(discount, customer, externalCustomerLoyaltyTierId)) {
            return false;
        }
        // Loyalty points
        if (!exports.canDiscountPassLoyaltyPointsRestriction({ discount: discount, remainingLoyaltyPoints: remainingLoyaltyPoints || 0, isGrowthLoyaltyActive: isGrowthLoyaltyActive })) {
            return false;
        }
        // Products
        var excludeProductIds = discount.products.filter(function (p) { return p.type === 'exclude'; }).map(function (p) { return p.id; });
        var includeProductIds = discount.products.filter(function (p) { return p.type === 'include'; }).map(function (p) { return p.id; });
        if (excludeProductIds.length > 0) {
            if (excludeProductIds.includes(productId || '')) {
                return false;
            }
        }
        if (includeProductIds.length > 0) {
            if (!includeProductIds.includes(productId || '')) {
                return false;
            }
        }
        // Categories
        var excludeCategoryIds = [];
        var discountExcludeCategoryIds = discount.categories.filter(function (p) { return p.type === 'exclude'; }).map(function (p) { return p.id; });
        discountExcludeCategoryIds.forEach(function (c) {
            flattenedCategories.forEach(function (fc) {
                if (fc.id === c) {
                    excludeCategoryIds.push(fc.id);
                }
                else if (fc.parentCategoryId === c) {
                    excludeCategoryIds.push(fc.id);
                }
            });
        });
        var includeCategoryIds = [];
        var discountIncludeCategoryIds = discount.categories.filter(function (p) { return p.type === 'include'; }).map(function (p) { return p.id; });
        discountIncludeCategoryIds.forEach(function (c) {
            flattenedCategories.forEach(function (fc) {
                if (fc.id === c) {
                    includeCategoryIds.push(fc.id);
                }
                else if (fc.parentCategoryId === c) {
                    includeCategoryIds.push(fc.id);
                }
            });
        });
        if (excludeCategoryIds.length > 0 && categoryId) {
            if (excludeCategoryIds.includes(categoryId)) {
                return false;
            }
        }
        if (includeCategoryIds.length > 0) {
            if (!categoryId && !includeProductIds.includes(productId || '')) {
                return false;
            }
            if (categoryId && !includeCategoryIds.includes(categoryId)) {
                return false;
            }
        }
        // Time/Date
        if (!shouldOverrideDiscountsTimeRestrictions && !exports.canDiscountPassTimeRestriction(discount, timezone)) {
            return false;
        }
        if (automatic) {
            return discount.automatic;
        }
        return true;
    });
};
//# sourceMappingURL=discounts.js.map